import { Autorizacion, PaginadoAutorizaciones } from '../../pages/autorizaciones/models'
import { keysToSnake } from '../../utils/ObjetosUtil'
import { baseApi } from './base.api'

export const autorizacionesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Contrato HTTP de autorizaciones ambientales.
     * Los filtros se envian en snake_case y la respuesta vuelve normalizada por `baseApi`.
     */
    recuperarAutorizaciones: builder.query<
      PaginadoAutorizaciones,
      { pagina: number; registrosPorPagina: number; autorizacion?: string }
    >({
      query: (arg) => {
        return {
          url: `${window._env_.API_CONTEXTO_AUTORIZACIONES}`,
          params: keysToSnake(arg),
        }
      },
    }),

    recuperarAutorizacionPorId: builder.query<Autorizacion, string>({
      query: (idAutorizacion) => `${window._env_.API_CONTEXTO_AUTORIZACIONES}/${idAutorizacion}`,
    }),

    recuperarAutorizacionesPorSitio: builder.query<Autorizacion, string>({
      query: (idSitio) => `${window._env_.API_CONTEXTO_AUTORIZACIONES}/sitios/${idSitio}`,
    }),

    guardarAutorizacion: builder.mutation({
      query: (autorizacion) => {
        return {
          url: `${window._env_.API_CONTEXTO_AUTORIZACIONES}/`,
          method: 'POST',
          body: keysToSnake(autorizacion),
        }
      },
    }),

    actualizarAutorizacion: builder.mutation({
      query: ({ idAutorizacion, ...autorizacion }) => {
        return {
          url: `${window._env_.API_CONTEXTO_AUTORIZACIONES}/${idAutorizacion}`,
          method: 'PUT',
          body: keysToSnake(autorizacion),
        }
      },
    }),

    recuperarAutorizacionAutocomplete: builder.query<any, string>({
      query: (autorizacion) =>
        `${window._env_.API_CONTEXTO_AUTORIZACIONES}/autocomplete?autorizacion=${autorizacion}`,
    }),
  }),
})

export const {
  useRecuperarAutorizacionesQuery,
  useGuardarAutorizacionMutation,
  useActualizarAutorizacionMutation,
  useRecuperarAutorizacionPorIdQuery,
  useLazyRecuperarAutorizacionesPorSitioQuery,
  useLazyRecuperarAutorizacionAutocompleteQuery,
} = autorizacionesApi
